// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ylnp6","title":"style_title__5dbkt","list":"style_list__Cf8e0"};